<template>
  <div class="tarber">
    <div @click="goIndex">
      <div class="icon" :class="[tupleActives[0] ? 'icon-currentIndex' : 'icon-index']"></div>
      <span>首页</span>
    </div>
    <div @click="goOrderList">
      <div class="icon" :class="[tupleActives[1] ? 'icon-currentOrder' : 'icon-order']"></div>
      <span>购票记录</span>
    </div>
    <div @click="goUser">
      <div class="icon" :class="[tupleActives[2] ? 'icon-currentUser' : 'icon-user']"></div>
      <span>个人中心</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tarber",
  data(){
    return {
      tupleActives: [false, false, false],
    }
  },
  methods: {
    goIndex(){
      if(
        this.$route.name === 'individualticketlist' ||
        this.$route.name === 'hmtticketlist' ||
        this.$route.name === 'groupticketlist'
      )return;
      if(this.$route.name === 'orderList'){
        return this.$route.params.ordertype === '0' ? this.$router.push('/individualticketlist') : this.$router.push('/groupticketlist');
      }
      if(this.$route.name === 'user'){
        return this.$router.push('/individualticketlist');
      }
      if(this.$route.name === 'useGuide'){
        return this.$router.push('/groupticketlist');
      }
    },
    goOrderList(){
      if(this.$route.name === 'orderList')return;
      // 无导游信息查看是否曾经提交过，有记录根据提交地址跳转方向
      this.$router.push('/orderlist/0');
    },
    goUser(){
      if(
        this.$route.name === 'useGuide' ||
        this.$route.name === 'userDomestic' ||
        this.$route.name === 'userPandaHouse' ||
        this.$route.name === 'userAbroad'
        ){
        return
      }
      const checkGuideState = this.$checkGuideState();
      // 无导游信息查看是否曾经提交过，有记录根据提交地址跳转方向
      if(checkGuideState){
        this.$router.push('/userguide');
      }else{
        this.$router.push('/user')
      };
    },
  },
  watch: {
    '$route': {
      handler(router) {
        this.tupleActives.forEach((item, index) => {
          this.tupleActives[index] = false
        });
        if(
          router.name === 'individualticketlist' ||
          router.name === 'hmtticketlist' ||
          router.name === 'zg' ||
          router.name === 'qnd' ||
          router.name === 'sls' ||
          router.name === 'groupticketlist'){
          this.tupleActives[0] = true;
        };
        if(router.name === 'orderList' || router.name === 'pandaHouseOrderList'){
          this.tupleActives[1] = true;
        };
        if(router.name === 'user' || router.name === 'useGuide'){
          this.tupleActives[2] = true;
        };
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang='less'>
.tarber {
  height: 1.333333rem;
  position: fixed;
  width: 100%;
  background: rgb(248, 248, 248);
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  line-height: 1;
  padding: 0 1.066667rem;
  border-top: 1px solid #fff;
  div {
    font-size: 0.133333rem * 2;
    color: #8e8e93;
    .icon{
      margin: 0 auto .2rem;
    }
    span {
      display: inline-block;
      min-width: 4em;
    }
    &:first-child .icon{
      width: 0.746666rem;
      height: 0.64rem;
    }
    &:nth-child(2) .icon{
      height: .333333rem * 2;
      width: .28rem * 2;
    }
    &:last-child .icon{
      width: .346667rem * 2;
      height: .36rem * 2;
    }
  }
}

.icon-currentIndex{
  background-position: -2.67rem -0.59rem;
  background-size: 9.7rem 2.6rem;
}
.icon-index{
  background-position: -2.67rem -1.31rem;
  background-size: 9.7rem 2.6rem;
}
.icon-currentOrder{
  background-position: -1.32rem -0.57rem;
  background-size: 9.7rem 2.6rem;
}
.icon-order{
  background-position: -1.32rem -1.3rem;
  background-size: 9.7rem 2.6rem;
}
.icon-currentUser{
  background-position: -1.95rem -0.55rem;
  background-size: 9.7rem 2.6rem;
}
.icon-user{
  background-position: -1.95rem -1.3rem;
  background-size: 9.7rem 2.6rem;
}
</style>
